import { useQuery } from '@tanstack/react-query'
import { getW2WorkItemsInReview, WorkItemInReview } from 'api/w2/review'
import { w2Keys } from './keys'

export const useW2WorkItemsInReview = () =>
  useQuery<WorkItemInReview[]>({
    queryKey: w2Keys.itemsInReview,
    queryFn: getW2WorkItemsInReview,
  })
